
const state = {
  username: 'Princewill Iroka',
  token: localStorage.getItem('token'),
};
export default state
